import {Component} from '@angular/core';
import {OpenAPIService} from '../services/openapi';
import {SecretService} from '../services/secret';

declare let window:any;

const SORT_SECURITY_DEFINITIONS = function(d1, d2) {
  if (d1.type === d2.type) return 0;
  if (d1.type === 'oauth2') return -1;
  if (d2.type === 'oauth2') return 1;
  return 0;
}

@Component({
    selector: 'auth',
    templateUrl: '../views/authentication-modal.pug',
    styles: [`
      .nav-tabs {
        margin-bottom: 15px;
      }
    `],
})
export class AuthComponent {
  securityDefinitions:any[];
  securityDefinition:any;
  scopes:any[];
  addedScopes:any = {};
  error:string;

  subscriptions:any[] = [];

  constructor(private openapi:OpenAPIService,
              private secrets:SecretService) {
    this.subscriptions.push(this.openapi.spec.subscribe(spec => {
      if (!spec) return;
      if (this.openapi.parsed.securityDefinitions) {
        this.securityDefinitions = this.iterateObject(this.openapi.parsed.securityDefinitions);
        this.securityDefinitions.sort((d1, d2) => SORT_SECURITY_DEFINITIONS(d1.value, d2.value));
        if (this.securityDefinitions.length) this.setSecurityDefinition(this.securityDefinitions[0].value);
      } else {
        this.securityDefinitions = [];
        this.securityDefinition = null;
      }
    }));
  }

  setSecurityDefinition(def) {
    this.securityDefinition = def;
    if (def.type === 'oauth2') {
      this.scopes = this.iterateObject(def.scopes || {});
    } else {
      this.scopes = [];
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  closeModal() {
    window.jQuery('#AuthenticationModal').modal('hide');
  }

  submit() {
    this.error = null;
    if (this.securityDefinition.type !== 'oauth2') {
      this.secrets.setSecrets(this.secrets.secrets);
      this.closeModal();
      return;
    }

    let scopes = Object.keys(this.addedScopes).filter(name => this.addedScopes[name]);
    this.openapi.startOAuth(this.securityDefinition, scopes)
      .then(() => this.closeModal())
      .catch(e => this.error = e.message);
  }

  iterateObject(obj) {
    return Object.keys(obj).map(k => ({key: k, value: obj[k]}))
  }

  setAllScopes(val=false) {
    this.scopes.forEach(iter => {
      this.addedScopes[iter.key] = val;
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/auth.ts